/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".data-block__value__override[_ngcontent-%COMP%]{text-align:right}.icons-container[_ngcontent-%COMP%]{white-space:nowrap}.not-ok[_ngcontent-%COMP%]{background-color:#ffcfd6}.delete-icon[_ngcontent-%COMP%], .edit-icon[_ngcontent-%COMP%]{padding:0;margin:0}#add_btn[_ngcontent-%COMP%]{background-color:#00b6ac}"];
export { styles as styles };
